
import Vue from 'vue';
import { State } from '@/stores/auth';

declare module 'vue/types/vue' {
  interface Vue {
    $auth: State;
  }
}
export default Vue.extend({
  computed: {
    $auth(): State {
      return this.$stores.auth.state;
    },
  },
});
